import { defineMessages } from 'react-intl';

export const agentCreditAllowanceBannerMessages = defineMessages({
  exhaustedTitle: {
    defaultMessage: 'You used up your usage.',
    id: '4Hr/SIfaRB',
    description:
      'In-chat credit banner title when Clinician usage remaining is at or below zero',
  },
  exhaustedDescription: {
    defaultMessage:
      'Resets {date}, {time}. Upgrade to Clinician Max to {multiplier}x your Heidi usage.',
    id: 'VSeARxFvpF',
    description:
      'In-chat credit banner description when Clinician usage remaining is at or below zero. multiplier is 10 for FREE or trialing users, 5 for paid Clinician.',
  },
  exhaustedDescriptionPracticeMax: {
    defaultMessage:
      'Resets {date}, {time}. Upgrade to Practice Max to {multiplier}x your Heidi usage.',
    id: '+rUiSpoPP/',
    description:
      'In-chat credit banner description when a Practice Standard seat has used up its usage. multiplier is 10 for FREE or trialing users, 5 for a paid seat.',
  },
  complimentaryTitle: {
    defaultMessage: 'You used up 100% of your usage limit',
    id: '+YstOXcbm4',
    description:
      'In-chat complimentary credit banner title for Clinician Max at remaining zero',
  },
  complimentaryDescription: {
    defaultMessage:
      "As one of our power users, here's complimentary usage until the 31st of October on us",
    id: 'QSn/9AITC5',
    description:
      'In-chat complimentary credit banner description for Clinician Max until 31 October',
  },
});
